<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改收款单' : '新增收款单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="140px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收款类型" prop="fundCollectOrderTypeEnum">
          <EnumSelect
            enumName="FundCollectOrderTypeEnum"
            :multiple="false"
            placeholder="请选择收款类型"
            v-model="headInfo.fundCollectOrderTypeEnum"
            @change="changeTypeEnum"
          >
          </EnumSelect>
        </el-form-item>

        <div v-if="headInfo.fundCollectOrderTypeEnum == 'SaleOrder'">
          <el-form-item label="客户" prop="customerSupplierId">
            <CustomerSelect
              :value="customer"
              @select="selectCustomer"
            ></CustomerSelect>
          </el-form-item>
          <el-row :gutter="10" v-if="headInfo.customerSupplierId">
            <el-col :span="6">
              <el-form-item label="联系人信息" prop="customerSupplierId">
                <el-input
                  v-model="headInfo.customerSupplierName"
                  placeholder="请输入联系人姓名"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierPhoneNumber"
                  placeholder="请输入联系方式"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="10" prop="customerId">
                <el-input
                  v-model="headInfo.customerSupplierAddress"
                  placeholder="请输入联系地址"
                  :disabled="!orderConfig.editCustomer"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div v-else>
          <el-form-item label="供应商" prop="customerSupplierId">
            <SupplierSelect
              :value="supplier"
              @select="selectSupplier"
            ></SupplierSelect>
          </el-form-item>

          <el-form-item
            label="使用供应商余额"
            class="fm-mt-10"
            prop="useBalance"
          >
            <el-tooltip
              slot="label"
              effect="dark"
              content=""
              placement="top-start"
            >
              <div slot="content" style="line-height: 1.5em">
                <div style="font-weight: bold">使用供应商余额说明</div>
                使用供应商余额将直接扣减或增加供应商余额，无需选择收款的资金账户。
              </div>
              <div>
                <i class="el-icon el-icon-question fm-mr-5"></i>
                <span>使用供应商余额</span>
              </div>
            </el-tooltip>
            <div class="fm-flex">
              <el-switch
                v-model="headInfo.useBalance"
                :active-color="$jsTool.getColor('success')"
                :inactive-color="$jsTool.getColor('warning')"
              >
              </el-switch>
              <p
                v-fmtype="'success'"
                class="fm-ml-10"
                v-if="headInfo.useBalance"
              >
                使用
              </p>
              <span v-fmtype="'warning'" class="fm-ml-10" v-else>不使用</span>
            </div>
          </el-form-item>
        </div>

        <el-form-item label="所选单据" required>
          <div class="fm-flex">
            <p v-fmtype="'success'" v-if="itemList && itemList.length > 0">
              {{ "共 " + itemList.length + " 个单据" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择单据</span>
            <span>，收款总额：</span>
            <FmAmount :amount="headInfo.collectTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectOrderPage"
              >选择单据</el-button
            >
          </div>
        </el-form-item>

        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            prop="orderNo"
            label="关联单号"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ getRelatedOrder(scope.row).orderNo }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="单据金额"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="getRelatedOrder(scope.row).orderAmount"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="collectAmount"
            label="收款金额"
            width="190"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.collectAmount"
                :key="
                  'collectAmountInputNumber' + scope.$index + collectAmountKey
                "
                size="small"
                :precision="2"
                :min="0"
                :max="getToBeCollectAmount(scope.row)"
                :step="1"
                @change="
                  (value) =>
                    changeItemCollectAmount(scope.$index, scope.row, value)
                "
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="优惠金额"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="实收金额"
            width="190"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.itemAmount"
                size="small"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.collectAmount == 'string'
                    ? Number(scope.row.collectAmount)
                    : scope.row.collectAmount
                "
                :step="1"
                @change="
                  (value) => changeItemAmount(scope.$index, scope.row, value)
                "
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click.native.stop="removeItem(scope.row)"
                type="text"
                icon="el-icon-delete"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item
          v-if="
            headInfo.fundCollectOrderTypeEnum == 'SaleOrder' ||
            !headInfo.useBalance
          "
          label="资金账户"
          prop="fundAccountId"
          class="fm-mt-10"
          key="fundAccountId"
        >
          <FundAccountSelect
            :value="fundAccount"
            @select="selectFundAccount"
          ></FundAccountSelect>
        </el-form-item>

        <el-form-item label="收款优惠" prop="disCountAmount" class="fm-mt-10">
          <div style="height: 32px" class="fm-flex">
            <FmAmount :amount="headInfo.disCountAmount"></FmAmount>
          </div>
        </el-form-item>

        <el-form-item label="单据金额" prop="orderAmount">
          <div style="height: 32px" class="fm-flex">
            <FmAmount :amount="headInfo.orderAmount"></FmAmount>
          </div>
        </el-form-item>

        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadFundCollectOrderPaperOrder + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="收款凭证"
          class="fm-mt-10"
          prop="collectVoucherSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in collectVoucherImageList"
            :key="index"
          >
            <el-image
              :id="'collectVoucherImage' + index"
              :src="file.url"
              :preview-src-list="collectVoucherImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="collectVoucherFilePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="collectVoucherFileDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="
              $envConfig.VUE_APP_uploadFundCollectOrderCollectVoucher + ''
            "
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="collectVoucherImageList"
            :show-file-list="false"
            :on-change="collectVoucherFileChange"
            :on-success="collectVoucherFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="collectVoucherImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="50"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入单据备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <SaleOrderSelectDialog
      :show="saleOrderSelectDialogShow"
      :customerId="customer.id"
      from="FundCollectOrder"
      :selectList="itemList"
      @close="saleOrderSelectDialogShow = false"
      @selectSaleOrder="selectSaleOrder"
      v-if="saleOrderSelectDialogShow"
    >
    </SaleOrderSelectDialog>

    <PurchaseReturnOrderSelectDialog
      :show="purchaseReturnOrderSelectDialogShow"
      :supplierId="supplier.id"
      from="FundCollectOrder"
      :selectList="itemList"
      @close="purchaseReturnOrderSelectDialogShow = false"
      @selectPurchaseReturnOrder="selectPurchaseReturnOrder"
      v-if="purchaseReturnOrderSelectDialogShow"
    >
    </PurchaseReturnOrderSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebFundCollectOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            this.initOrderData();
            this.getOrderConfig();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        fundCollectOrderTypeEnum: this.$ruleUtil.simple({
          fieldName: "收款类型",
          handleType: "选择",
          required: true,
        }),
        customerSupplierId: this.$ruleUtil.simple({
          fieldName: "客户/供应商",
          handleType: "选择",
          required: true,
        }),
        saleUserIdList: this.$ruleUtil.array("业务员", "选择", 1),
        paperOrderSysFileIdList: this.$ruleUtil.array(
          "纸质单据",
          "上传",
          this.orderConfig.paperOrderRequired ? 1 : 0,
          10
        ),
        collectVoucherSysFileIdList: this.$ruleUtil.array(
          "收款凭证",
          "上传",
          this.orderConfig.collectVoucherRequired ? 1 : 0,
          10
        ),
        remark: this.$ruleUtil.simple({
          fieldName: "备注",
          required: false,
          max: 200,
        }),
      };
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        res.customerSupplierName = this.$ruleUtil.simple({
          fieldName: "联系人姓名",
          required: true,
          max: 50,
        });
        res.customerSupplierPhoneNumber = this.$ruleUtil.simple({
          fieldName: "联系方式",
          required: true,
          max: 20,
        });
        res.customerSupplierAddress = this.$ruleUtil.simple({
          fieldName: "联系地址",
          required: true,
          max: 20,
        });
      }
      if (
        this.headInfo.fundCollectOrderTypeEnum == "SaleOrder" ||
        !this.headInfo.useBalance
      ) {
        res.fundAccountId = this.$ruleUtil.simple({
          fieldName: "资金账户",
          handleType: "选择",
          required: true,
        });
      }
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        paperOrderRequired: true,
        collectVoucherRequired: true,
      },

      // 预选的单据信息
      preInfo: {
        saleOrderId: null,
        saleOrder: {},
        purchaseReturnOrderId: null,
        purchaseReturnOrder: {},
      },

      orderDatePickerShow: false,
      fundCollectOrderTypeEnumPickerShow: false,

      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        fundCollectOrderTypeEnum: "",
        orderDate: null,
        customerSupplierId: null,
        customerSupplierName: null,
        customerSupplierPhoneNumber: null,
        customerSupplierAddress: "",
        useBalance: true,
        fundAccountId: null,
        collectTotalAmount: "0.00",
        disCountAmount: "0.00",
        orderAmount: "0.00",
        saleUserIdList: [],
        paperOrderSysFileIdList: [],
        collectVoucherSysFileIdList: [],
        remark: "",
        orderParam: "",
      },
      itemList: [],
      customer: {},
      supplier: {},
      fundAccount: {},
      saleUserList: [],
      paperOrderImageList: [],
      collectVoucherImageList: [],

      saleOrderSelectDialogShow: false,
      purchaseReturnOrderSelectDialogShow: false,

      collectAmountKey: "null",
    };
  },
  methods: {
    removeItem(row) {
      this.itemList.splice(
        this.itemList.findIndex((d) => d.itemNo == row.itemNo),
        1
      );
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
    },
    changeItemCollectAmount(index, row, value) {
      row = {
        ...row,
        collectAmount: value,
        disCountAmount: 0,
        itemAmount: value,
      };
      this.itemList.splice(
        this.itemList.findIndex((d) => d.itemNo == row.itemNo),
        1,
        row
      );
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
      this.collectAmountKey = Math.random();
    },
    changeItemAmount(index, row, value) {
      if (
        (row.itemAmount || Number(row.itemAmount) == 0) &&
        (row.collectAmount || Number(row.collectAmount) == 0)
      ) {
        row.disCountAmount = this.$jsTool.sub(
          row.collectAmount,
          row.itemAmount
        );
      } else {
        row.disCountAmount = "0.00";
      }
      this.itemList.splice(
        this.itemList.findIndex((d) => d.itemNo == row.itemNo),
        1,
        row
      );
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
    },
    getToBeCollectAmount(row) {
      let res;
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        res = row.relatedSaleOrderHead.toBeCollectAmount;
      } else {
        res = row.relatedPurchaseReturnOrderHead.toBeCollectAmount;
      }
      return typeof res == "string" ? Number(res) : res;
    },
    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },
    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 收款凭证有关
    collectVoucherFilePreview(index) {
      document.getElementById("collectVoucherImage" + index).click();
    },
    collectVoucherFileDelete(index, file) {
      this.collectVoucherImageList.splice(index, 1);
      this.initCollectVoucherSysFileIdList();
    },
    collectVoucherFileChange(file, fileList) {
      if (file.status == "ready") {
        this.collectVoucherImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCollectVoucherSysFileIdList();
    },
    collectVoucherFileSuccess(res, file, fileList) {
      let index = this.collectVoucherImageList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.collectVoucherImageList.splice(index, 1, {
          ...this.collectVoucherImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.collectVoucherImageList.splice(index, 1);
      }
      this.initCollectVoucherSysFileIdList();
    },
    initCollectVoucherSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.collectVoucherSysFileIdList = this.collectVoucherImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField(
          "collectVoucherSysFileIdList"
        );
      });
    },

    getRelatedOrder(row) {
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        return row.relatedSaleOrderHead;
      } else {
        return row.relatedPurchaseReturnOrderHead;
      }
    },
    selectFundAccount(item) {
      this.headInfo.fundAccountId = item.id;
      this.fundAccount = item;
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("fundAccountId");
      });
    },
    selectCustomer(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = item.name;
      this.headInfo.customerSupplierPhoneNumber = item.phoneNumber;
      this.headInfo.customerSupplierAddress = item.address;
      this.customer = item;
      this.itemList = [];
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
      this.$message.success("已自动更新联系人信息");
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrderPage();
      }, 200);
    },
    selectSupplier(item) {
      this.headInfo.customerSupplierId = item.id;
      this.headInfo.customerSupplierName = "";
      this.headInfo.customerSupplierPhoneNumber = "";
      this.headInfo.customerSupplierAddress = "";
      this.supplier = item;
      this.itemList = [];
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerSupplierId");
      });
      setTimeout(() => {
        this.toSelectOrderPage();
      }, 200);
    },
    // 选择销售单
    toSelectOrderPage() {
      if (this.preInfo.saleOrderId || this.preInfo.purchaseReturnOrderId) {
        this.$message.error("自动创建收款单时无法重新选择收款单据");
        return;
      }
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        if (!this.customer || !this.customer.id) {
          this.$message.error("请先选择客户");
          return;
        }
        this.saleOrderSelectDialogShow = true;
      } else {
        if (!this.supplier || !this.supplier.id) {
          this.$message.error("请先选择供应商");
          return;
        }
        this.purchaseReturnOrderSelectDialogShow = true;
      }
    },
    selectSaleOrder(itemList) {
      this.itemList = itemList;
      this.headInfo.collectTotalAmount = this.$jsTool.sum(
        itemList.map((d) => d.collectAmount)
      );
      this.headInfo.disCountAmount = this.$jsTool.sum(
        itemList.map((d) => d.disCountAmount)
      );
      this.headInfo.orderAmount = this.$jsTool.sum(
        itemList.map((d) => d.itemAmount)
      );
      this.saleOrderSelectDialogShow = false;
    },
    selectPurchaseReturnOrder(itemList) {
      this.itemList = itemList;
      this.headInfo.collectTotalAmount = this.$jsTool.sum(
        itemList.map((d) => d.collectAmount)
      );
      this.headInfo.disCountAmount = this.$jsTool.sum(
        itemList.map((d) => d.disCountAmount)
      );
      this.headInfo.orderAmount = this.$jsTool.sum(
        itemList.map((d) => d.itemAmount)
      );
      this.purchaseReturnOrderSelectDialogShow = false;
    },
    initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.fundCollectOrderTypeEnum = "SaleOrder";
      this.headInfo.saleUserIdList = [this.$storageUtil.getUserInfo().id];
      this.saleUserList = [this.$storageUtil.getUserInfo()];
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:FundCollectOrder:NeedApproval",
        "Order:FundCollectOrder:EditCustomer",
        "Order:FundCollectOrder:PaperOrderRequired",
        "Order:FundCollectOrder:CollectVoucherRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
        let collectVoucherRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:CollectVoucherRequired"
        );
        if (
          collectVoucherRequiredIndex > -1 &&
          res.data[collectVoucherRequiredIndex].value == "false"
        ) {
          this.orderConfig.collectVoucherRequired = false;
        }
      }
    },
    async getOrderInfo(args) {
      let res = await this.$api.fundCollectOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          fundCollectOrderTypeEnum: res.data.head.fundCollectOrderTypeEnum.Name,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
          paperOrderSysFileIdList: res.data.head.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
          collectVoucherSysFileIdList:
            res.data.head.collectVoucherImageList.map((d) => d.sysFile.id),
        };
        this.itemList = res.data.itemList;
        this.customer = res.data.head.customer;
        this.supplier = res.data.head.supplier;
        this.fundAccount = res.data.head.fundAccount;
        this.saleUserList = res.data.head.saleUserList.map((d) => d.user);
        this.paperOrderImageList = res.data.head.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        this.collectVoucherImageList =
          res.data.head.collectVoucherImageList.map((item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          });
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.saleOrderId = orderParam.preInfo.saleOrderId;
          this.preInfo.purchaseReturnOrderId =
            orderParam.preInfo.purchaseReturnOrderId;
        }
      }
    },
    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.fundCollectOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.fundCollectOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.fundCollectOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.fundCollectOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    changeTypeEnum() {
      //   this.headInfo.fundCollectOrderTypeEnum = e.value[0].Name;
      this.headInfo.customerSupplierId = null;
      this.headInfo.customerSupplierName = null;
      this.headInfo.customerSupplierPhoneNumber = null;
      this.headInfo.customerSupplierAddress = "";
      this.headInfo.useBalance =
        this.headInfo.fundCollectOrderTypeEnum == "PurchaseReturnOrder";
      this.customer = {};
      this.supplier = {};
      this.itemList = [];
      if (this.headInfo.fundCollectOrderTypeEnum == "SaleOrder") {
        this.selectSaleOrder(this.itemList);
      } else {
        this.selectPurchaseReturnOrder(this.itemList);
      }
      this.$refs.editOrderFormRef.clearValidate("fundAccountId");
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("fundCollectOrderTypeEnum");
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/FundCollectOrderEditDialog.vue